export var Actions;
(function (Actions) {
    Actions["GET_LIST"] = "getTravelokaTransactionListlAction";
})(Actions || (Actions = {}));
export var Mutations;
(function (Mutations) {
    Mutations["SET_TRAVELOKA_TRANSACTION_LIST"] = "setTravelokaTransactionListMutation";
    Mutations["SET_TRAVELOKA_TRANSACTION_LIST_LOADING"] = "setTravelokaTransactionListLoadingMutation";
    Mutations["SET_TRAVELOKA_TRANSACTION_LIST_PAGINATION"] = "setTravelokaTransactionPaginationMutation";
})(Mutations || (Mutations = {}));
